import { OperationPayload } from '../operation-payload.model';

export class InviteDispatcherPayload implements OperationPayload {
  path = '/accounts/dispatchers';
}
